module.exports = __webpack_public_path__ + "img/IEC13758.85f6a1d6.png";